/**
 *
 * Asynchronously loads the component for Fonts
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
